__turbopack_context__.v({
  "day": "RjiVaq_day",
  "dayInRange": "RjiVaq_dayInRange",
  "dayName": "RjiVaq_dayName",
  "dayNum": "RjiVaq_dayNum",
  "daySelected": "RjiVaq_daySelected",
  "dayToday": "RjiVaq_dayToday",
  "inverse": "RjiVaq_inverse",
  "monthLabel": "RjiVaq_monthLabel",
  "monthLabelCell": "RjiVaq_monthLabelCell",
  "monthLabelsRow": "RjiVaq_monthLabelsRow",
  "root": "RjiVaq_root",
  "scroller": "RjiVaq_scroller",
});
